import aircraft from "@/app/csr-src/assets/icons/aircraft.png";
import styles from "./index.module.scss";
import withHeaderFooter from "@/app/csr-src/hocs/with-header-footer";
import { Helmet } from "react-helmet";

const PageNotFound = withHeaderFooter(() => {
  return (
    <div className={styles["centered-container"]}>
      <Helmet>
        <title>Page Not Found | Joybuy</title>
        <meta
          name="description"
          content="Oops! The page you're looking for cannot be found. Explore top products with fast shipping and delivery guarantee at Joybuy.com. Return to the homepage for great deals!"
        />
      </Helmet>
      <img src={aircraft.src} alt="404 not found" />
      <div className={styles.title}>404 Page Not Found</div>
    </div>
  );
});

export default PageNotFound;
